import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FilterDrawerComponent } from '../filter-drawer/filter-drawer.component';
import { MapViewComponent } from '../map-view/map-view.component';
import { PinDetailSheetComponent } from '../pin-detail-sheet/pin-detail-sheet.component';
import { PlanSheetComponent } from '../trip-builder/plan-sheet/plan-sheet.component';
import { PlanSidebarComponent } from '../trip-builder/plan-sidebar/plan-sidebar.component';

@Component({
  selector: '#planner-root',
  standalone: true,
  imports: [
    MapViewComponent,
    PinDetailSheetComponent,
    PlanSheetComponent,
    PlanSidebarComponent,
    FilterDrawerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './planner-page.component.html',
  styleUrl: './planner-page.component.css',
})
export class PlannerPageComponent {}
